import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThermometer = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M9.634,17.898l1.805,-0.214c0.446,-0.053 0.861,-0.254 1.179,-0.572l7.221,-7.221c1.549,-1.549 1.549,-4.06 0,-5.608v0c-1.549,-1.549 -4.06,-1.549 -5.608,0l-7.221,7.221c-0.318,0.318 -0.519,0.733 -0.572,1.179l-0.214,1.805c-0.053,0.446 -0.254,0.861 -0.572,1.179l-1.937,1.937c-0.774,0.774 -0.774,2.03 0,2.804v0c0.774,0.774 2.03,0.774 2.804,0l1.937,-1.937c0.316,-0.319 0.732,-0.52 1.178,-0.573Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M17.22,10.23l1.14,1.14" }),
			/* @__PURE__ */ _jsx("path", { d: "M15.07,12.32l1.17,1.17" }),
			/* @__PURE__ */ _jsx("path", { d: "M12.95,14.44l1.17,1.17" }),
			/* @__PURE__ */ _jsx("path", { d: "M16.33,7.79l-6.79,6.79" }),
			/* @__PURE__ */ _jsx("path", { d: "M4.81,16.5l2.8,2.81" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgThermometer;
